import { useDispatch } from "react-redux";

import {
  openConnectServicesActivationModal,
  closeConnectServicesActivationModal,
} from "../../reducers/addonsReducer";
import { useConnectServicesActivationModalState } from "../../reducers/addonsReducer/selectors";

/**
 * Hook for managing the Connect Services activation modal through Redux state.
 *
 * Returns `isOpen` (whether the modal is open) plus `open` and `close`.
 */
export const useConnectServicesActivationModal = () => {
  const dispatch = useDispatch();
  const { show } = useConnectServicesActivationModalState() as { show: boolean };

  return {
    isOpen: show,
    open: () => dispatch(openConnectServicesActivationModal()),
    close: () => dispatch(closeConnectServicesActivationModal()),
  };
};

export default useConnectServicesActivationModal;
